"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addParkingLot = addParkingLot;
exports.deleteParkingLot = deleteParkingLot;
exports.getParkingLotDetail = getParkingLotDetail;
exports.getParkingLotList = getParkingLotList;
exports.updateParkingLot = updateParkingLot;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取停车场列表
 * @param {Object} params - 查询参数
 */
function getParkingLotList(params) {
  return (0, _request.default)({
    url: '/admin/parking/lot/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取停车场详情
 * @param {number} id - 停车场ID
 */
function getParkingLotDetail(id) {
  return (0, _request.default)({
    url: "/admin/store/parkingLot/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 新增停车场
 * @param {Object} data - 停车场数据
 */
function addParkingLot(data) {
  return (0, _request.default)({
    url: '/admin/store/parkingLot/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑停车场
 * @param {Object} data - 停车场数据
 */
function updateParkingLot(data) {
  return (0, _request.default)({
    url: '/admin/store/parkingLot/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除停车场
 * @param {number} id - 停车场ID
 */
function deleteParkingLot(id) {
  return (0, _request.default)({
    url: "/admin/store/parkingLot/delete/".concat(id),
    method: 'GET'
  });
}